import axiosInstance from "../services/axiosInstance";

export const loadTermsConditions = async () => {
  try {
    const response = await axiosInstance.post("../termsconditions/load");
    return response.data;
  } catch (error) {
    if (error.response?.data) {
      return error.response.data;
    }

    throw error;
  }
};
